<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div :class="{ bgblack: showMenu }">
    <menu-a :show="showMenu"> </menu-a>
    <div class="">
      <div
        class="flex flex-col h-screen justify-center"
        :class="{ mainbody: showMenu }"
        v-on="{ click: showMenu ? closeMenu : null }"
      >
        <main-header @showMenu="showMenuHandler" :title="headerTitle">
        </main-header>
        <main class="mb-auto bg-black">
          <router-view />
        </main>
        <footer-a> </footer-a>
      </div>
    </div>
  </div>
</template>
<script>
import footerA from "./footer.vue";
import mainHeader from "./header.vue";
import menuA from "./menu.vue";
export default {
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  mounted() {
    this.title = this.$route.meta.prtitle;
    var token = localStorage.getItem("token");
    if (token == null) {
      this.$router.push({ name: "Register" });
    }
  },
  data() {
    return {
      title: null,
      showMenu: false,
    };
  },
  methods: {
    showMenuHandler() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      console.log("sdklhj");
      this.showMenu = false;
    },
  },
  components: {
    footerA,
    mainHeader,
    menuA,
  },
};
</script>
<style scoped>
.h-home {
  height: 100vh;
}
</style>
